export const SDK_RETRY_BASE_MS = 500;

export const SDK_RETRY_CAP_MS = 4000;
